import Loading from '@/components/common/Loading';
import { selectDoc } from '@/pages/doc/stores/doc-store';
import { Empty, Layout } from 'antd';
import gameletIcon from 'assets/icons/gamelet.png';
import * as React from 'react';
import { useSelector } from 'react-redux';
import {
    BrowserRouter as Router, Route, Routes
} from 'react-router-dom';
import { localize } from '../locale/lang';
import MainNav from './MainNav';
import { navs } from './navs';
const { Header, Content, Sider, Footer } = Layout;

export default function () {
    const doc = useSelector(selectDoc)
    return (
    <Router>
        <Layout style={{minWidth: '863px'}}>
            <Header className="app-header" style={{
                display: 'flex',
                position: 'fixed',
                zIndex: 100,
                width: '100%',
                minWidth: '863px',
            }}>
                <div className="logo" style={{minWidth: 200, marginLeft: -50, height: '100%', }}>
                    <h1 style={{
                        color: '#fff',
                        paddingLeft: 10,
                        // textTransform: 'uppercase',
                    }}>
                        <img src={gameletIcon} height={52} />
                        <span>{localize('headerTitle', {editionTitle: doc.edition.title})}</span>
                    </h1>
                </div>
                <div style={{flex: 'auto'}}>
                    <MainNav />
                </div>
            </Header>
            <Layout>
                    <Content
                        className="app-content"
                        style={{
                            margin: 0,
                            marginTop: 64,
                        }}
                    >
                        <Routes>
                            {
                                Object.entries(navs).map(([path, nav]) => {
                                    return (
                                        <Route
                                            key={nav.key}
                                            path={path}
                                            element={
                                                <React.Suspense fallback={<Loading />}>
                                                    {
                                                    nav.page.componentInstance ? (nav.page.componentInstance) :
                                                        (nav.page.component ? <nav.page.component /> : <Empty />)
                                                    }
                                                </React.Suspense>
                                            }
                                        />
                                    );
                                })
                            }
                        </Routes>
                    </Content>
            </Layout>
            {/* <Footer style={{textAlign: 'center'}} className="app-footer">
                ©Copyright devoszhang 2022
            </Footer> */}
        </Layout>
    </Router>
    );
}
